import React from "react";
import Card from "./Card";
import Slider from "react-slick";
import offerOne from '../../../assets/images/swift-dzire.png'
import offerTwo from '../../../assets/images/innova-crysta.png'
import offerThree from '../../../assets/images/kia-carnival.png'
import offerFour from '../../../assets/images/bmw-series-5.png'



const CardDeatils = () => {
    const cardsData = [
        {
            image: `${offerOne}`,
            title: "Economy",
          
        },
        {
            image: `${offerTwo}`,
            title: "MUV",
    
        },
        {
            image: `${offerThree}`,
            title: "Family car",
        },
        {
            image: `${offerFour}`,
            title: "Luxury",
            
        },
    ];
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrow:true,
        responsive: [
          {
            breakpoint: 1024, 
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600, 
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
    };
    return (
        <Slider {...settings} >
            {cardsData.map((card, index) => (
                <Card
                    key={index}
                    image={card.image}
                    title={card.title}
                    customClass="px-2"
                    parentClass="popular-section"
                    card="card1"
                    cardBody="cardBody"
                    
                />
            ))}
        </Slider>
    );
};

export default CardDeatils;
